var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-with-button',{attrs:{"title":_vm.pes_card.title,"text":_vm.pes_card.text,"buttonLink":_vm.pes_card.buttonLink,"imgLink":_vm.pes_card.imgLink}})}
var staticRenderFns = []

export { render, staticRenderFns }